import React, { useState } from "react";
import { useSpring, animated, easings } from "react-spring";

import iconPlus from '../../Images/IconPlus.svg'
import iconMinus from '../../Images/IconMinus.svg'

import "../componentsStyle.css"
import Regenerate from "../Regenerate/Regenerate";

const PdmSingles = (props) => {
    const { showMaximumChat, data, updateMessage, loading ,sessionId,index ,setIsFeedbackPop ,messages ,checkThumsDownFeedback } = props


    const fadeInProps = useSpring({
        from: { opacity: Math.random() },
        to: { opacity: 1 },
        config: { duration: 1000, easing: easings.easeInOut },
        // Adjust duration and easing as needed
    });

 
      


    return (
        <div className="server-text-response-body">

            {<>
                <div className="channel-list-reponse" style={{ color: '#220046' }}>{data?.llm_response?.Text || data?.text}</div>
                <Regenerate msg={data} fadeInProps={fadeInProps} updateMessage={updateMessage} showMaximumChat={showMaximumChat} setIsFeedbackPop={setIsFeedbackPop} index={index} messages={messages} sessionId={sessionId} checkThumsDownFeedback={checkThumsDownFeedback} />


            </>}

        </div>
    )
}

export default PdmSingles
